import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import GbitTableHeaderCol from './GbitTableHeaderCol';
import GbitTableRow from './GbitTableRow';
import GbitTablePaging from './GbitTablePaging';
import $ from 'jquery';
import { dbPost } from '../../apis/commonApi';

const GbitTable = forwardRef(
  (
    {
      modalService,
      tableName,
      headerList,
      bodyList,
      initChecker,
      onHeaderClick,
      onCellClick,
      watchHeader,
      watchBody,
      children,
      pageNow = 1,
      pageSize = 10,
      pageChange,
    },
    ref
  ) => {
    const [storedUrl, setStoredUrl] = useState(null);
    const [storedParam, setStoredParam] = useState(null);
    const [pagingYn, setPagingYn] = useState(true);
    const [pagingSize, setPagingSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCnt, setTotalCnt] = useState(0);

    const [headerInfo, setHeaderInfo] = useState([]);
    const [dataInfo, setDataInfo] = useState([]);

    const [widthJudge, setWidthJudge] = useState(false);

    useImperativeHandle(ref, () => {
      return {
        getHeaderList() {
          return $.extend(true, [], headerInfo);
        },
        setHeaderList(dataList) {
          setHeaderInfo($.extend(true, [], dataList));
        },
        getDataList() {
          return $.extend(true, [], dataInfo);
        },
        setDataList(dataList) {
          setDataInfo($.extend(true, [], dataList));
        },
        getRowObj(row) {
          return $.extend(true, {}, dataInfo[row]);
        },
        setRowObj(row, rowData) {
          const copyData = $.extend(true, [], dataInfo);
          copyData[row] = rowData;
          setDataInfo(copyData);
        },
        async doQuery(url, param) {
          setStoredUrl(url);
          setStoredParam(param);
          await doQueryFunc(url, param);
        },
        resetData(newData) {
          setDataInfo(newData);
        },
      };
    });

    const doQueryFunc = async (url, param) => {
      const tempParam = $.extend(true, {}, param);

      if (pagingYn) {
        tempParam.pageSize = pagingSize;
        tempParam.currentPage = currentPage;
      }

      let response = null;

      try {
        response = await dbPost(url, tempParam);

        if (response instanceof Error) {
          modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else {
          if (pagingYn && response.length > 0) {
            setTotalCnt(response[0].totalCount);
          }
          setDatas(response);
        }
      } catch (error) {
        modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      }
    };

    useEffect(() => {
      setWidthJudge(false);

      if (headerList != null && headerList.length > 0) {
        for (let index = 0; index < headerList.length; index++) {
          const element = headerList[index];
          if (element.width != null) {
            setWidthJudge(true);
          }
        }

        setHeaderInfo($.extend(true, [], headerList));
        setDataInfo($.extend(true, [], bodyList));
      }
    }, [initChecker === true]);

    const headerClickEvt = headerInfo => {
      onHeaderClick(headerInfo);
    };

    const headerChangeEvt = (headerInfo, value) => {
      if (watchHeader !== undefined && watchHeader !== null) {
        watchHeader(headerInfo, value);
      }
    };

    const bodyClickEvt = cellInfo => {
      onCellClick(cellInfo);
    };

    const bodyChangeEvt = (info, value) => {
      onCellClick(info, value);
      let copyData = [...dataInfo];

      // const rowIndex = info.rowNo - 1; // rowNo는 1부터 시작하므로 인덱스는 0부터 시작
      const rowIndex = info.rowNo; // rowNo는 1부터 시작하므로 인덱스는 0부터 시작
      if (copyData[rowIndex]) {
        copyData[rowIndex][info.key] = value;
        setDataInfo(copyData);

        if (watchBody !== undefined && watchBody !== null) {
          watchBody(info, value);
        }
      }
    };

    useEffect(() => {}, [bodyList]);

    return (
      <>
        <div className="tbl-wrap">
          <table className="tbl col data scroll">
            {/* <colgroup>
              {widthJudge &&
                headerInfo != null &&
                headerInfo.length > 0 &&
                headerInfo[headerInfo.length - 1].length > 0 &&
                headerInfo[headerInfo.length - 1].map(item => {
                  return <col style={{ width: `${item.width}` }} />;
                })}
            </colgroup> */}
            <thead>
              <tr>
                {headerInfo != null && headerInfo.length > 0 && (
                  <>
                    {headerInfo.map((item, index) => {
                      return (
                        <GbitTableHeaderCol
                          key={index}
                          tableName={tableName + '_0'}
                          keyVal={item.key}
                          labelType={item.labelType}
                          labelOption={item?.labelOption ?? ''}
                          dataType={item.dataType}
                          dataOption={item?.dataOption ?? ''}
                          name={item.name}
                          width={item.width}
                          headerClicked={info => headerClickEvt(info)}
                          headerChange={(info, value) =>
                            headerChangeEvt(info, value)
                          }
                          initHeaderValue={item.initHeaderValue}
                        />
                      );
                    })}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {dataInfo.map(row => {
                return (
                  <GbitTableRow
                    tableName={tableName}
                    headerInfo={headerInfo}
                    rowData={row}
                    rowClick={info => bodyClickEvt(info)}
                    rowChange={(info, value) => {
                      bodyChangeEvt(info, value);
                    }}
                  />
                );
              })}
              {children}
            </tbody>
          </table>
        </div>
        {bodyList?.length > 0 && (
          <GbitTablePaging
            totalItems={parseInt(dataInfo?.[0]?.totalCount)}
            itemsPerPage={pageSize}
            currentPage={pageNow}
            onPageChange={value => {
              pageChange(value);
            }}
          />
        )}
      </>
    );
  }
);

export default GbitTable;
